module.exports = __webpack_public_path__ + "static/media/bike.5d2a32d4.jpg";